import { render } from "./CGJView.vue?vue&type=template&id=84195430&scoped=true&ts=true"
import script from "./CGJView.vue?vue&type=script&lang=ts"
export * from "./CGJView.vue?vue&type=script&lang=ts"

import "./CGJView.vue?vue&type=style&index=0&id=84195430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84195430"]])

export default __exports__